import { DateTime } from 'luxon';

export function chartAxisDateFormatter(date: Date) {
  console.log('dateFormatter called');
  console.log(date);
  return DateTime.fromJSDate(date).toFormat('MM/yy');
}

export function dateFormatter(date: DateTime) {
  return date.toLocaleString(DateTime.DATE_SHORT, { locale: 'de-DE' });
}
